// extracted by mini-css-extract-plugin
export var statItem = "_i2-1";
export var statsRow = "_i2-0";